import { lazy, type ComponentType } from 'react';

export const SvgSetupTeamUpdateFigma: ComponentType = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/confluence-account-setup_svg-setup-team-update-figma" */ './SetupTeamUpdateFigma'
		),
);

export const SvgSetupTeamUpdateGdrive: ComponentType = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/confluence-account-setup_svg-setup-team-update-gdrive" */ './SetupTeamUpdateGdrive'
		),
);

export const SvgSetupTeamUpdateGithub: ComponentType = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/confluence-account-setup_svg-setup-team-update-github" */ './SetupTeamUpdateGithub'
		),
);

export const SvgSetupTeamUpdateOnedrive: ComponentType = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/confluence-account-setup_svg-setup-team-update-onedrive" */ './SetupTeamUpdateOnedrive'
		),
);

export const SvgSetupTeamUpdateSlack: ComponentType = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/confluence-account-setup_svg-setup-team-update-slack" */ './SetupTeamUpdateSlack'
		),
);
